module.exports = __webpack_public_path__ + "static/media/Andorra.83791388.png";